module.exports = __webpack_public_path__ + "static/img/企业文化7.cee72063.png";